<div class="container-fluid">
  <div class="row mt-3">
    <div class="col">
      <h3>Select a Vendor</h3>
      <hr />
      <ul>
        <li>Below Select a Vendor to assign Contract to.</li>
        <li>
          Once a Vendor is selected, a vendor contact form will appear with the
          vendor's primary contact info populated.
        </li>
        <li>Edit the Contact info with a different contact if you wish.</li>
      </ul>
    </div>
  </div>
  <div class="row">
    <div class="col" style="height: 500px">
      <app-company-vendors-grid
        [gridName]="'ClientVendors'"
        [selectedRowsPrimaryKeys]="selectedRowsPrimaryKeys"
        (rowClick)="actionEvent({ action: 'view', rowData: $event.data })"
      ></app-company-vendors-grid>
    </div>
  </div>

  @if (selectedVendor) {
    <div class="row mt-3">
      <div class="col d-flex">
        <h3>Add Vendor Contact Information</h3>
      </div>
      <hr />
    </div>
  }
  @if (selectedVendor) {
    <form class="row" [formGroup]="vendorContactForm">
      <div class="col">
        <div class="row g-3">
          <div class="col-4">
            <label for="firstName" class="form-label"
              >First Name<span class="required-field-asterisk">*</span></label
            >
            <input
              type="text"
              class="form-control"
              id="firstName"
              formControlName="firstName"
            />
          </div>
          <div class="col-4">
            <label for="lastName" class="form-label"
              >Last Name<span class="required-field-asterisk">*</span></label
            >
            <input
              type="text"
              class="form-control"
              id="lastName"
              formControlName="lastName"
            />
          </div>
          <div class="col-4">
            <label for="jobTitle" class="form-label">Job Title</label>
            <input
              type="text"
              class="form-control"
              id="jobTitle"
              formControlName="jobTitle"
            />
          </div>
        </div>
        <div class="row g-3">
          <div class="col-3">
            <label for="phone" class="form-label"
              >Mobile / Primary Phone<span class="required-field-asterisk"
                >*</span
              ></label
            >
            <input
              type="tel"
              class="form-control"
              id="phone"
              placeholder="(___)___-____"
              [inputMask]="phoneMask"
              formControlName="phone1"
            />
          </div>
          <div class="col">
            <label for="ext" class="form-label">Ext.</label>
            <input
              type="tel"
              class="form-control"
              id="ext"
              formControlName="ext"
            />
          </div>
          <div class="col-3">
            <label for="phone2" class="form-label"
              >Work / Secondary Phone</label
            >
            <input
              type="tel"
              class="form-control"
              id="phone2"
              placeholder="(___)___-____"
              [inputMask]="phoneMask"
              formControlName="phone2"
            />
          </div>
          <div class="col">
            <label for="ext2" class="form-label">Ext.</label>
            <input
              type="tel"
              class="form-control"
              id="ext2"
              formControlName="ext2"
            />
          </div>
          <div class="col-3">
            <label for="email" class="form-label"
              >Email<span class="required-field-asterisk">*</span></label
            >
            <input
              type="email"
              class="form-control"
              id="email"
              formControlName="email"
            />
          </div>
        </div>
        <div class="row" formGroupName="StreetAddress">
          <div class="col-3">
            <label for="contactAddress" class="form-label"
              >Address<span class="required-field-asterisk">*</span></label
            >
            <input
              type="text"
              class="form-control"
              id="contactAddress"
              formControlName="address1"
            />
          </div>
          <div class="col-3">
            <label for="contactAddress2" class="form-label">Address 2</label>
            <input
              type="text"
              class="form-control"
              id="contactAddress2"
              formControlName="address2"
            />
          </div>
          <div class="col-2">
            <label for="contactCity" class="form-label"
              >City<span class="required-field-asterisk">*</span></label
            >
            <input
              type="text"
              class="form-control"
              id="contactCity"
              formControlName="city"
            />
          </div>
          <div class="col-2">
            <label for="contactState" class="form-label"
              >{{
                localizationInfo && localizationInfo.territory
                  ? localizationInfo.territory.label
                  : 'State'
              }}<span class="required-field-asterisk">*</span></label
            >
            <select class="form-select" formControlName="state">
              @for (item of states; track item) {
                <option [ngValue]="item.abbreviation">
                  {{ item.name }}
                </option>
              }
            </select>
          </div>
          <div class="col-2">
            <label for="contactZip" class="form-label"
              >{{
                localizationInfo && localizationInfo.postalCode
                  ? localizationInfo.postalCode.label
                  : 'Zip'
              }}<span class="required-field-asterisk">*</span></label
            >
            <input
              type="text"
              class="form-control"
              id="contactZip"
              formControlName="zip"
            />
          </div>
        </div>
      </div>
    </form>
  }
</div>
